import classnames from 'classnames';
import * as React from 'react';
import { createElement } from 'react';
import TouchFeedback from 'rmc-feedback';
import './style/index.less';
export class Brief extends React.Component {
    render() {
        return (createElement("div", { className: "im-list-brief", style: this.props.style }, this.props.children));
    }
}
class ListItem extends React.Component {
    constructor(props) {
        super(props);
        this.onClick = (ev) => {
            const { onClick, platform } = this.props;
            const isAndroid = platform === 'android';
            if (Boolean(onClick) && isAndroid) {
                if (this.debounceTimeout) {
                    clearTimeout(this.debounceTimeout);
                    this.debounceTimeout = null;
                }
                const Item = ev.currentTarget;
                const RippleWidth = Math.max(Item.offsetHeight, Item.offsetWidth);
                const ClientRect = ev.currentTarget.getBoundingClientRect();
                const pointX = ev.clientX - ClientRect.left - Item.offsetWidth / 2;
                const pointY = ev.clientY - ClientRect.top - Item.offsetWidth / 2;
                const coverRippleStyle = {
                    width: `${RippleWidth}px`,
                    height: `${RippleWidth}px`,
                    left: `${pointX}px`,
                    top: `${pointY}px`,
                };
                this.setState({
                    coverRippleStyle,
                    RippleClicked: true,
                }, () => {
                    this.debounceTimeout = setTimeout(() => {
                        this.setState({
                            coverRippleStyle: { display: 'none' },
                            RippleClicked: false,
                        });
                    }, 1000);
                });
            }
            if (onClick) {
                onClick(ev);
            }
        };
        this.state = {
            coverRippleStyle: { display: 'none' },
            RippleClicked: false,
        };
    }
    componentWillUnmount() {
        if (this.debounceTimeout) {
            clearTimeout(this.debounceTimeout);
            this.debounceTimeout = null;
        }
    }
    render() {
        const { prefixCls, className, activeStyle, error, align, wrap, disabled, children, multipleLine, thumb, extra, arrow, onClick, hideBottomLine, title, line, subTitle, ...restProps } = this.props;
        const { platform, ...otherProps } = restProps;
        const { coverRippleStyle, RippleClicked } = this.state;
        const wrapCls = classnames(`${prefixCls}-item`, className, {
            [`${prefixCls}-item-disabled`]: disabled,
            [`${prefixCls}-item-error`]: error,
            [`${prefixCls}-item-top`]: align === 'top',
            [`${prefixCls}-item-middle`]: align === 'middle',
            [`${prefixCls}-item-bottom`]: align === 'bottom',
        });
        const rippleCls = classnames(`${prefixCls}-ripple`, {
            [`${prefixCls}-ripple-animate`]: RippleClicked,
        });
        const lineCls = classnames({
            [`${prefixCls}-line`]: line,
            [`${prefixCls}-line-new`]: !line,
            [`${prefixCls}-line-multiple`]: multipleLine,
            [`${prefixCls}-line-wrap`]: wrap,
            [`${prefixCls}-line-hideBottomLine`]: hideBottomLine,
        });
        const arrowCls = classnames(`${prefixCls}-arrow`, {
            [`${prefixCls}-arrow-horizontal`]: arrow === 'horizontal',
            [`${prefixCls}-arrow-vertical`]: arrow === 'down' || arrow === 'up',
            [`${prefixCls}-arrow-vertical-up`]: arrow === 'up',
        });
        const content = (createElement("div", Object.assign({}, otherProps, { onClick: ev => {
                this.onClick(ev);
            }, className: wrapCls }),
            thumb ? (createElement("div", { className: `${prefixCls}-thumb` }, typeof thumb === 'string' ? createElement("img", { src: thumb }) : thumb)) : null,
            createElement("div", { className: lineCls },
                title ? (createElement("div", { className: `${prefixCls}-content` },
                    title,
                    subTitle ? createElement(Brief, null, subTitle) : null)) : null,
                children !== undefined && (createElement("div", { className: `${prefixCls}-content` }, children)),
                extra !== undefined && (createElement("div", { className: `${prefixCls}-extra` }, extra)),
                arrow && createElement("div", { className: arrowCls, "aria-hidden": "true" })),
            createElement("div", { style: coverRippleStyle, className: rippleCls })));
        const touchProps = {};
        Object.keys(otherProps).forEach(key => {
            if (/onTouch/i.test(key)) {
                touchProps[key] = otherProps[key];
                delete otherProps[key];
            }
        });
        return (createElement(TouchFeedback, Object.assign({}, touchProps, { disabled: disabled || !onClick, activeStyle: activeStyle, activeClassName: `${prefixCls}-item-active` }), content));
    }
}
ListItem.defaultProps = {
    prefixCls: 'im-list-wrap',
    align: 'middle',
    error: false,
    multipleLine: false,
    wrap: false,
    platform: 'ios',
    hideBottomLine: false,
    lang: 'zh-cn'
};
ListItem.Brief = Brief;
export default ListItem;
